// 折扣码管理
class DiscountManager {
    constructor() {
        this.discounts = [];
        this.init();
    }

    init() {
        // 所有点击都通过 body 委托处理 add 按钮
        document.body.addEventListener('click', (e) => {
            if (e.target.id === 'add-discount-btn') {
                const input = document.getElementById('discount-code-input');
                if (input) {
                    const code = input.value.trim();
                    if (code) {
                        this.addDiscount(code);
                        input.value = '';
                    }
                } else {
                    console.warn('未找到折扣码输入框');
                }
            }
        });

        // 删除折扣保持原有委托
        document.addEventListener('click', (e) => {
            if (e.target.classList.contains('cart-drawer__remove-discount')) {
                const discountTitle = e.target.parentElement.dataset.discount;
                this.removeDiscount(discountTitle);
            }
        });
    }
    // 保存折扣码列表到 localStorage
    saveToLocalStorage() {
        try {
            localStorage.setItem('cart_discounts', JSON.stringify(this.discounts));
        } catch (e) {
            console.warn('无法保存折扣码到本地存储', e);
        }
    }

    // 从 localStorage 加载折扣码
    loadFromLocalStorage() {
        try {
            const saved = localStorage.getItem('cart_discounts');
            if (saved) {
                const parsed = JSON.parse(saved);
                if (Array.isArray(parsed)) {
                    this.discounts = parsed;
                    this.renderDiscounts();
                    this.updateTotals();
                }
            }
        } catch (e) {
            console.warn('无法读取本地存储中的折扣码', e);
        }
    }
    // 添加折扣码
    addDiscount(code) {
        if (!code) return;

        // 调用 Shopify API 验证折扣码
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: code })
        })
            .then(response => response.json())
            .then(cart => {
                if (cart.discount_codes.length > 0 && cart.discount_codes.some(dc => dc.applicable === true)) {
                    this.discounts.push(code);
                    this.renderDiscounts();
                    this.updateTotals();
                } else {
                    showDiscountMessage('', 'error');
                }
            });
    }

    // 移除折扣码
    removeDiscount(code) {
        fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' }) // 先清空折扣
        })
            .then((o) => {
                // 重新添加剩余折扣码
                const remainingDiscounts = this.discounts.filter(d => d !== code);
                this.discounts = remainingDiscounts;

                if (remainingDiscounts.length > 0) {
                    fetch('/cart/update.js', {
                        method: 'POST',
                        headers: { 'Content-Type': 'application/json' },
                        body: JSON.stringify({ discount: remainingDiscounts.join(',') })
                    });
                }

                this.renderDiscounts();
                this.updateTotals();
            });
    }

    // 渲染折扣码列表
    renderDiscounts() {
        const listContainer = document.getElementById('discount-list');
        if (!listContainer) return; // 安全退出

        listContainer.innerHTML = this.discounts.map(code => `
        <div class="cart-drawer__discount-item" data-discount="${code}">
            <span>${code}</span>
            <button type="button" class="cart-drawer__remove-discount">×</button>
        </div>
    `).join('');
    }

    // 更新费用明细
    updateTotals() {
        fetch('/cart.js')
            .then(response => response.json())
            .then(cart => {
                // 金额格式化函数（处理空值和非数字）
                const formatMoney = (amount) => {
                    // 确保 amount 是数字（默认 0 当值为 null/undefined 时）
                    const numericAmount = Number(amount) || 0;
                    // 转换为元并保留 2 位小数，添加货币符号
                    return `$${(numericAmount / 100).toFixed(2)}`;
                };

                // 1. 折扣金额（关键：使用正确的字段 cart.total_discounts）
                const discountAmount = cart.total_discount || 0; // 无折扣时默认为 0
                document.getElementById('discountAmount').textContent = `-${formatMoney(discountAmount) }`;

                // 2. 其他金额（确保字段正确）
                document.getElementById('totalPrice').textContent = formatMoney(cart.total_price + window.shopData.fixedShipping); // 包含固定运费
                // document.getElementById('total').textContent = formatMoney(cart.total_price);
                
                // document.querySelector('.cart-drawer__grand-total span').textContent = formatMoney(cart.total_price);
            })
            .catch(error => {
                console.error('error', error);
                // 出错时显示 0 避免 NaN
                document.getElementById('discountAmount').textContent = '$0.00';
            });
    }
}

// 初始化折扣管理器
new DiscountManager();

// 初始化折扣管理器
document.addEventListener('DOMContentLoaded', () => {
    const discountManager = new DiscountManager();
    discountManager.loadFromLocalStorage();

    // 自定义事件触发购物车更新
    document.addEventListener('cart:request-update', () => {
        discountManager.syncDiscounts();
    });
});
/**
 * 折扣码提示信息工具
 * @param {string} message - 提示内容
 * @param {string} type - 类型：'error'（错误）、'success'（成功）
 */
function showDiscountMessage(message, type = 'error') {
    // 获取提示信息元素
    const errorEl = document.getElementById('discount-error');

    // 如果元素不存在，创建一个（兼容未添加HTML的情况）
    if (!errorEl) {
        const newErrorEl = document.createElement('div');
        newErrorEl.id = 'discount-error';
        newErrorEl.className = 'cart-drawer__discount-error';
        document.querySelector('.cart-drawer__discounts').appendChild(newErrorEl);
    }

    // 更新内容和样式
    const messageEl = document.getElementById('discount-error');
    messageEl.textContent = message;
    messageEl.className = 'cart-drawer__discount-error'; // 重置样式
    messageEl.classList.add(`discount-${type}`); // 添加类型样式
    messageEl.classList.add('show'); // 显示提示

    // 成功提示3秒后自动隐藏
    if (type === 'success') {
        setTimeout(() => {
            messageEl.classList.remove('show');
        }, 3000);
    }
}